﻿import React, { useState, useEffect } from 'react';
//Components
import _MaskedInput from 'react-text-mask';
const MaskedInput = _MaskedInput.default ?? _MaskedInput;
import Button from '@mui/material/Button';
import { FormControl, FormHelperText } from '@mui/material';
import LoadingIndicator from 'components/Global/loading-indicator/loading-indicator';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Select,
  MenuItem,
  TextField,
} from '@mui/material';
import Alert from '@mui/material/Alert';
import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
//Utilities
import useForm from '../../../../AdminContentMgt/Components/useForm';
import { useQuery } from '@tanstack/react-query';
//API
import {
  GetGenderList,
  GetSilverGuardTypeList,
  PrintForm,
  GetServiceFormText,
  PrintCheckList,
  GetCheckoutSituationForms,
  SetAdditionalInformation,
  GetCheckoutSituationId,
  PrintAllForms,
  GetAgeList,
  GetProductListAll,
} from 'api/apppackage';
import { GetResponses, GetStates } from 'api/referencedata';
import { fetchSignedURL } from '../../../../../api/file';
import { Snackbar } from '../../../../../components/Global/Snackbar/Snackbar';
import { useNavigate, useLocation } from 'react-router-dom';

export default function CheckoutList({ handleCheckOutList, fastForms }) {
  let routePrefix = 'Applications';
  const navigate = useNavigate();
  const location = useLocation();
  const productValues = location.state?.productValues ?? null;
  const paramsForm = productValues;
  const [forms, setForms] = useState([]);

  const displayValue = (val) => (val === 'NA' ? 'No' : val);

  //BL-4243 - Update to eApp Lite Warning message in App Package
  function eAppLiteWarning() {
    return (
      <div>
        If you need forms for <span style={{ fontWeight: 'bold' }}>eApp Lite</span>, click{' '}
        <span style={{ fontWeight: 'bold' }}>Print All Forms</span>. A new tab will open. Go to that
        tab and use the <span style={{ fontWeight: 'bold' }}>Download</span> button to save the
        document to your device.
        <span style={{ fontWeight: 'bold' }}> Do not </span>use{' '}
        <span style={{ fontWeight: 'bold' }}>Print to PDF</span>.
      </div>
    );
  }

  {
    /*Styles*/
  }
  const formTitle = {
    padding: '0 0.5em 0 0',
    fontWeight: 'bold',
  };

  const formValue = {
    fontWeight: '300',
    display: 'inline-block',
  };

  const modalRow = {
    padding: '0 0 0.25em 0',
  };

  const [stateDisclosure, setStateDisclosure] = useState('0');
  const stateDisclosureCode = { Yes: '1', No: '0', "Don't Know": '2' };
  const [serviceForms, setServiceForms] = useState(null);
  const urlParams = new URLSearchParams(window.location.search);
  const printPath = 'https://inspeednow.baltlife.com/PackagePDF/';
  const getStateList = useQuery({
    queryKey: ['GetStates'],
    queryFn: () => GetStates()(),
  });
  const getYesNoList = useQuery({
    queryKey: ['GetResponses'],
    queryFn: () => GetResponses()(),
  });
  const getAgeList = useQuery({
    queryKey: ['GetAgeList'],
    queryFn: () => GetAgeList()(),
  });
  const productListQuery = useQuery({
    queryKey: ['GetProductListAll'],
    queryFn: () => GetProductListAll()(),
  });
  const getGenderList = useQuery({
    queryKey: ['getGenderList'],
    queryFn: () => GetGenderList()(),
  });
  const getSilverGuardTypeList = useQuery({
    queryKey: ['getSilverGuardTypeList', 0],
    queryFn: () => GetSilverGuardTypeList()(),
  });

  const getServiceFormTextQuery = useQuery({
    queryKey: ['GetServiceFormText', parseInt(urlParams.get('id'))],
    queryFn: () => GetServiceFormText({ AppID: urlParams.get('id') })(),
  });
  const getCheckoutSituationId = useQuery({
    queryKey: ['GetCheckoutSituationId', parseInt(urlParams.get('id'))],
    queryFn: () => GetCheckoutSituationId({ AppID: urlParams.get('id') })(),
  });
  const checkOutSituationFormsQuery = useQuery({
    queryKey: ['GetCheckoutSituationForms', parseInt(urlParams.get('id'))],
    queryFn: () =>
      GetCheckoutSituationForms({
        appID: parseInt(urlParams.get('id')),
        bline: urlParams.get('bline'),
        Form: [],
      })(),
  });

  const [productID, setProductID] = useState(parseInt(urlParams.get('productid')));
  const [selectedFormID, setSelectedFormID] = useState(null);
  const printFormQuery = useQuery({
    queryKey: ['PrintForm', selectedFormID],
    queryFn: () =>
      PrintForm({
        AppID: parseInt(urlParams.get('id')),
        ProductID: parseInt(urlParams.get('productid')),
        BLine: urlParams.get('bline'),
        State: paramsForm.state ?? '',
        Calc: parseInt(stateDisclosureCode[stateDisclosure]),
        Referrer: urlParams.get('referrer'),
        CheckoutValues: checkoutValues,
        FormsList: forms.filter((f) => f.formId === selectedFormID),
      })(),
    enabled: selectedFormID != null,
  });

  const [fileFetchingID, setFileFetchingID] = useState(null);
  const [fileFetchIsError, setFileFetchIsError] = useState(false);
  const handleSecuredFile = async (formId) => {
    try {
      setFileFetchingID(formId);
      await fetchSignedURL(`/Forms/${formId}.pdf`);
    } catch (error) {
      setFileFetchingID(null);
      setFileFetchIsError(true);
    } finally {
      setFileFetchingID(null);
    }
  };

  const validate = (fieldValues = values) => {
    let temp = { ...errors };

    if (stateDisclosure === 'Yes') {
      let tmpAge = parseInt(fieldValues.age);
      let tmpAmountIns = parseInt(fieldValues.amountIns);
      let tmpADB = parseInt(fieldValues.adb);
      let tmpSilverGuardType = fieldValues.silverGuardType;

      if ('clientName' in fieldValues)
        temp.clientName =
          stateDisclosure === 'No' || fieldValues.clientName
            ? ''
            : 'Client Name is a required field.';
      if ('age' in fieldValues) temp.age = tmpAge ? '' : 'Age is a required field.';
      if ('adb' in fieldValues)
        temp.adb = tmpAge > 65 && tmpADB > 0 ? 'ADB must be No when over the age of 65.' : '';

      temp.agentName = fieldValues.agentName ? '' : 'Agent Name is a required field';
      temp.agency = fieldValues.agency ? '' : 'Agency is a required field';
      temp.address = fieldValues.address ? '' : 'Agency Address is a required field';
      temp.city = fieldValues.city ? '' : 'City is a required field';
      temp.state = fieldValues.state ? '' : 'State is a required field';
      temp.zipCode = fieldValues.zipCode ? '' : 'Agency ZIP Code is a required field';
      temp.phone = fieldValues.phone ? '' : 'Agency Phone is a required field';

      if (tmpSilverGuardType === 'SG2' && tmpADB === 1)
        temp.adb = 'ADB Rider is not available if the base plan is Special';

      if (tmpAge < 50) temp.age = 'Please enter a value greater than or equal to 50.';
      if (tmpAge > 80) temp.age = 'Please enter a value less than or equal to 80';

      if (
        fieldValues.amountIns === 0 ||
        fieldValues.amountIns === undefined ||
        fieldValues.amountIns === '' ||
        fieldValues.amountIns === null ||
        Number.isNaN(fieldValues.amountIns)
      ) {
        temp.amountIns = 'Amount Ins is a required field.';
      } else if (
        (tmpSilverGuardType === 'SG1LP' || tmpSilverGuardType === 'SG2') &&
        tmpAge >= 50 &&
        tmpAge <= 75 &&
        tmpAmountIns > 25000
      ) {
        temp.amountIns = 'Please enter a value less than or equal to 25000.';
      } else if (
        (tmpSilverGuardType === 'SG1LP' || tmpSilverGuardType === 'SG2') &&
        tmpAge >= 76 &&
        tmpAge <= 80 &&
        tmpAmountIns > 15000
      ) {
        temp.amountIns = 'Please enter a value less than or equal to 15000.';
      } else if (tmpSilverGuardType === 2 && tmpAmountIns > 15000) {
        temp.amountIns = 'Please enter a value less than or equal to 15000.';
      } else if (tmpSilverGuardType === 3 && tmpAmountIns > 10000) {
        temp.amountIns = 'Please enter a value less than or equal to 10000.';
      } else if (tmpAmountIns < 2500) {
        temp.amountIns = 'Please enter a value greater than or equal to 2500.';
      } else if (tmpAmountIns > 25000) {
        temp.amountIns = 'Please enter a value less than or equal to 25000.';
      } else if (tmpSilverGuardType === 'SG2' && tmpAmountIns > 15000) {
        temp.amountIns = 'Please enter a value less than or equal to 15000.';
      } else {
        temp.amountIns = '';
      }
    } else {
      //clear the fields if not using the state disclosure
      temp.clientName = '';
      temp.age = '';
      temp.adb = '';
      temp.amountIns = '';
      temp.agentName = '';
      temp.agency = '';
      temp.address = '';
      temp.city = '';
      temp.state = '';
      temp.zipCode = '';
      temp.phone = '';
    }

    setErrors({
      ...temp,
    });

    if (fieldValues == values) return Object.values(temp).every((x) => x == '');
  };

  const [form, setForm] = useState(null);

  const { values, errors, setErrors, setValues, handleDataChange } = useForm(form, true, validate);

  const setAdditionalInfo = useQuery({
    queryKey: ['setAdditionalInfo', urlParams.get('id')],
    queryFn: () =>
      SetAdditionalInformation(
        values
          ? {
              Id: parseInt(urlParams.get('id')),
              AppId: parseInt(urlParams.get('id')),
              ClientName: values.clientName,
              SilverGuardType: values.silverGuardType,
              SilverGuardName: '',
              Age: parseInt(values.age),
              Sex: parseInt(values.sex),
              ADB: values.silverGuardType === 'SG2' ? 0 : parseInt(values.adb),
              Tobacco: parseInt(values.tobacco),
              AmountIns: parseInt(values.amountIns),
              AgentName: values.agentName,
              Agency: values.agency,
              Address: values.address,
              City: values.city,
              State: values.state,
              ZipCode: values.zipCode,
              Phone: values.phone,
            }
          : {}
      )(),
    enabled: false,
    gcTime: 0,
  });

  useEffect(() => {
    HandleCreateCheckoutForm();
  }, [getGenderList.data, getSilverGuardTypeList.data]);

  const checkoutValues =
    paramsForm != null
      ? {
          AppId: parseInt(urlParams.get('id')) || 0,
          BusinessLine: urlParams.get('bline') ?? '',
          Product:
            productListQuery.data?.listValues?.find((p) => p.productID === paramsForm.product)
              ?.productName ?? paramsForm.product ?? '',
          AnnuityType: paramsForm.annuityType ?? null,
          State: paramsForm.state ?? '',
          FundSource: paramsForm.fundSource === 'NA' ? 'No' : paramsForm.fundSource ?? null,
          Existing: paramsForm.existing === 'NA' ? 'No' : paramsForm.existing ?? null,
          Replacement: paramsForm.replacement === 'NA' ? 'No' : paramsForm.replacement ?? null,
          InSpeed: paramsForm.inSpeed === 'NA' ? 'No' : paramsForm.inSpeed ?? null,
          Exchange: paramsForm.exchange === 'NA' ? 'No' : paramsForm.exchange ?? null,
          LapseSurrender:
            paramsForm.lapseSurrender === 'NA' ? 'No' : paramsForm.lapseSurrender ?? null,
          Rollover: paramsForm.rollover === 'NA' ? 'No' : paramsForm.rollover ?? null,
          Transfer: paramsForm.transfer === 'NA' ? 'No' : paramsForm.transfer ?? null,
          FullyUnderwritten:
            paramsForm.fullyUnderWritten === 'NA' ? 'No' : paramsForm.fullyUnderWritten ?? null,
          AgeId: paramsForm.age != null ? parseInt(paramsForm.age) : 0,
          Age:
            (getAgeList.data?.listValues?.find((a) => a.value === paramsForm.age)?.text ??
              paramsForm.age) ?? null,
          NumberOfChildren: paramsForm.numberOfChildren ?? null,
          SurrenderCharges:
            paramsForm.surrenderCharges === 'NA' ? 'No' : paramsForm.surrenderCharges ?? null,
        }
      : null;

  //TODO: Print ALL Forms uses correct URL
  const printAllFormsQuery = useQuery({
    queryKey: ['PrintAllForms'],
    queryFn: () =>
      PrintAllForms({
        AppID: parseInt(urlParams.get('id')),
        ProductID: parseInt(urlParams.get('productid')),
        BLine: urlParams.get('bline'),
        State: paramsForm.state ?? '',
        Calc: parseInt(stateDisclosureCode[stateDisclosure]),
        Referrer: urlParams.get('referrer'),
        CheckoutValues: checkoutValues,
        FormsList: fastForms,
      })(),
    enabled: false,
  });

  //TODO: Print Checklist uses correct URL
  const printCheckListQuery = useQuery({
    queryKey: ['PrintChecklist'],
    queryFn: () =>
      PrintCheckList({
        AppID: parseInt(urlParams.get('id')),
        ProductID: parseInt(urlParams.get('productid')),
        BLine: urlParams.get('bline'),
        State: paramsForm.state ?? '',
        Calc: 0,
        Referrer: urlParams.get('referrer'),
        CheckoutValues: checkoutValues,
        FormsList: fastForms,
      })(),
    enabled: false,
  });

  const HandleCreateCheckoutForm = () => {
    if (getGenderList.data != null && getSilverGuardTypeList.data != null) {
      let genderLstDefaultValue = getGenderList.data.listValues[0].value;
      let silverGuardDefaultValue = getSilverGuardTypeList.data.listValues.filter((o) =>
        o.value.includes('SG')
      )[0].value;
      let iProvideDefaultValue = getSilverGuardTypeList.data.listValues.filter((o) =>
        o.value.includes('OLA')
      )[0].value;

      let tmpID = parseInt(urlParams.get('id'));
      let type = silverGuardDefaultValue;
      if (tmpID == 4)
        //silver guard
        type = silverGuardDefaultValue;
      else if (tmpID == 15 || tmpID == 16) type = iProvideDefaultValue;

      setValues({
        id: tmpID,
        appId: parseInt(urlParams.get('id')),
        clientName: '',
        silverGuardType: type,
        age: 50,
        sex: genderLstDefaultValue,
        adb: 0,
        tobacco: 0,
        amountIns: 0,
        agentName: '',
        agency: '',
        address: '',
        city: '',
        state: '',
        zipCode: '',
        phone: '',
        serverFilePath: '',
        stateID: '',
      });
    }
  };

  useEffect(() => {
    if (getYesNoList.isSuccess && getYesNoList.data) {
      const noOption = getYesNoList.data.find(r => r.text === 'No');
      setStateDisclosure(noOption ? noOption.text : getYesNoList.data[0]?.text);
    }
  }, [getYesNoList.isSuccess, getYesNoList.data]);

  useEffect(() => {
    if (getServiceFormTextQuery.isSuccess && getServiceFormTextQuery.data) {
      if (
        getServiceFormTextQuery.data.listValues != null &&
        getServiceFormTextQuery.data.listValues !== undefined
      )
        setServiceForms(getServiceFormTextQuery.data.listValues);
    }
  }, [getServiceFormTextQuery.isSuccess, getServiceFormTextQuery.data]);

  useEffect(() => {
    if (checkOutSituationFormsQuery.isSuccess && checkOutSituationFormsQuery.data) {
      handleCheckOutList(checkOutSituationFormsQuery.data.form);
      setForms(fastForms != null ? fastForms : checkOutSituationFormsQuery.data.form);
    }
  }, [checkOutSituationFormsQuery.isSuccess, checkOutSituationFormsQuery.data]);

  useEffect(() => {
    if (printFormQuery.isSuccess && printFormQuery.data) {
      window.open(printPath + printFormQuery.data);
      setSelectedFormID(null);
    }
    if (printFormQuery.isError) {
      setSelectedFormID(null);
    }
  }, [printFormQuery.isSuccess, printFormQuery.data, printFormQuery.isError]);

  useEffect(() => {
    if (setAdditionalInfo.isSuccess && setAdditionalInfo.data) {
      printAllFormsQuery.refetch();
    }
  }, [setAdditionalInfo.isSuccess, setAdditionalInfo.data]);

  useEffect(() => {
    if (printAllFormsQuery.isSuccess && printAllFormsQuery.data) {
      window.open(printPath + printAllFormsQuery.data);
      setOpenAdditionalInfoModal(false);
    }
  }, [printAllFormsQuery.isSuccess, printAllFormsQuery.data]);

  useEffect(() => {
    if (printCheckListQuery.isSuccess && printCheckListQuery.data) {
      window.open(printPath + printCheckListQuery.data);
    }
    if (printCheckListQuery.isError && printCheckListQuery.error) {
      if (printCheckListQuery.error.indexOf('An error has occured') > -1)
        console.error('An error has occured with Print Checklist');
    }
  }, [
    printCheckListQuery.isSuccess,
    printCheckListQuery.data,
    printCheckListQuery.isError,
    printCheckListQuery.error,
  ]);

  const IsLoading = () => {
    if (
      getServiceFormTextQuery.isPending ||
      getCheckoutSituationId.isPending ||
      checkOutSituationFormsQuery.isPending ||
      getGenderList.isPending ||
      getSilverGuardTypeList.isPending ||
      getYesNoList.isPending ||
      getStateList.isPending
    )
      return true;

    return false;
  };

  const [openAdditionalInfoModal, setOpenAdditionalInfoModal] = useState(false);

  const Submit = () => {
    if (validate()) {
      var cont = true;

      if (stateDisclosure == 'Yes') {
        if (values.age > 65 && values.adb > 0) {
          cont = false;
        }
      }

      if (cont) {
        SubmitAdditionalInfo(
          parseInt(urlParams.get('id')),
          urlParams.get('productid'),
          urlParams.get('bline'),
          stateDisclosureCode[stateDisclosure]
        );
      }
    }
  };

  const SubmitAdditionalInfo = (id, prodId, bline, calcVal) => {
    if (calcVal != '0') {
      if (validate()) {
        setAdditionalInfo.refetch();
      }
    } else {
      printAllFormsQuery.refetch();
    }
  };

  function HandleExchangeVisibility() {
    if (paramsForm.rollover == null) return false;

    switch (productID) {
      case 17:
        return paramsForm.rollover === 'Yes';
      default:
        return false;
    }
  }

  const HandleParamsForm = () => {
    //BL-4408-IQumulateExceptions
    const hideExchange = HandleExchangeVisibility();
    const hideAnnuityType = !hideExchange && productID === 17;

    return (
      <div className="row">
        <div className="col-sm-4">
          <label style={formTitle} className="formLabel">
            Fully Underwritten:{' '}
          </label>
          <div id="productVal" style={formValue}>
            {displayValue(paramsForm.fullyUnderWritten)}
          </div>
        </div>
        <div className="col-sm-4">
          <label style={formTitle} className="formLabel">
            Product:{' '}
          </label>
          <div id="productVal" style={formValue}>
            {productListQuery.data?.listValues?.find((p) => p.productID === paramsForm.product)
              ?.productName ?? paramsForm.product}
          </div>
        </div>
        <div className="col-sm-4">
          <label style={formTitle} className="formLabel">
            State:
          </label>
          <div id="stateVal" style={formValue}>
            {paramsForm.state}
          </div>
        </div>
        .
        {paramsForm.fundSource != null && (
          <div className="col-sm-4">
            <label style={formTitle} className="formLabel">
              Fund Source:
            </label>
            <div id="stateVal" style={formValue}>
              {displayValue(paramsForm.fundSource)}
            </div>
          </div>
        )}
        {paramsForm.annuityType != null && !hideAnnuityType && (
          <div className="col-sm-4">
            <label style={formTitle} className="formLabel">
              Annuity Type:
            </label>
            <div id="annuityAnswer" style={formValue}>
              {paramsForm.annuityType}
            </div>
          </div>
        )}
        {paramsForm.existing != null && (
          <div className="col-sm-4">
            <label style={formTitle} className="formLabel" id="lblStndExisting">
              Existing Insurance or Annuity:{' '}
            </label>
            <div id="annuityAnswer" style={formValue}>
              {displayValue(paramsForm.existing)}
            </div>
          </div>
        )}
        {paramsForm.lapseSurrender != null && (
          <div className="col-sm-4">
            <label
              style={formTitle}
              className="formLabel"
              id="lblLapseSurrender"
              title="Policies Lapsed or Surrendered in the last 6 months"
            >
              Lapsed/Surrendered (6 mo):{' '}
            </label>
            <div id="lapseSurrenderAnswer" style={formValue}>
              {displayValue(paramsForm.lapseSurrender)}
            </div>
          </div>
        )}
        {paramsForm.replacement != null && (
          <div className="col-sm-4">
            <label style={formTitle} className="formLabel" id="lblReplace">
              {productID === 6 ? 'Replacement Critical Illness Policy:' : 'Replacement:'}
            </label>
            <div id="replacementAnswer" style={formValue}>
              {displayValue(paramsForm.replacement)}
            </div>
          </div>
        )}
        {paramsForm.exchange != null && !hideExchange && (
          <div className="col-sm-4">
            <label style={formTitle} className="formLabel" id="lblStndExchange">
              1035 Exchange:
            </label>
            <label style={formTitle} className="formLabel" id="lblIllExchange">
              BL Critical Illness Exchange:
            </label>
            <div id="existingAnswer" style={formValue}>
              {displayValue(paramsForm.exchange)}
            </div>
          </div>
        )}
        {paramsForm.inSpeed != null && (
          <div className="col-sm-4">
            <label style={formTitle} className="formLabel">
              InSpeed App:
            </label>
            <div id="inSpeedAnswer" style={formValue}>
              {displayValue(paramsForm.inSpeed)}
            </div>
          </div>
        )}
        {paramsForm.rollover != null && (
          <div className="col-sm-4">
            <label style={formTitle} className="formLabel">
              Rollover:
            </label>
            <div id="rolloverAnswer" style={formValue}>
              {displayValue(paramsForm.rollover)}
            </div>
          </div>
        )}
        {paramsForm.transfer != null && (
          <div className="col-sm-4">
            <label style={formTitle} className="formLabel">
              Transfer:
            </label>
            <div id="transferAnswer" style={formValue}>
              {displayValue(paramsForm.transfer)}
            </div>
          </div>
        )}
        {paramsForm.age != null && (
          <div className="col-sm-4">
            <label style={formTitle} className="formLabel">
              Age:
            </label>
            <div id="ageAnswer" style={formValue}>
              {getAgeList.data?.listValues?.find((a) => a.value === paramsForm.age)?.text ??
                paramsForm.age}
            </div>
          </div>
        )}
        {paramsForm.numberOfChildren != null && paramsForm.numberOfChildren.length > 0 && (
          <div className="col-sm-4">
            <label style={formTitle} className="formLabel">
              Number of Child Riders:
            </label>
            <div id="numberOfChildrenAnswer" style={formValue}>
              {paramsForm.numberOfChildren}
            </div>
          </div>
        )}
        {paramsForm.surrenderCharges != null && (
          <div className="col-sm-4">
            <label style={formTitle} className="formLabel">
              Surrender Charges:
            </label>
            <div id="surrenderChargesAnswer" style={formValue}>
              {displayValue(paramsForm.surrenderCharges)}
            </div>
          </div>
        )}
      </div>
    );
  };

  function showAdditionalInfo() {
    if (paramsForm == null) return false;

    let pID = parseInt(urlParams.get('productid'));

    if (paramsForm.state == 'ME') {
      //Silver Guard
      if (pID == 4) {
        setValues({
          ...values,
          ['silverGuardType']: getSilverGuardTypeList.data.listValues.filter((o) =>
            o.value.includes('SG')
          )[0].value,
        });
        return true;
      }
    }

    if (paramsForm.state == 'PA') {
      //Silver Guard or iProvide
      if (pID == 15 || pID == 16) {
        setValues({
          ...values,
          ['silverGuardType']: getSilverGuardTypeList.data.listValues.filter((o) =>
            o.value.includes('OLA')
          )[0].value,
        });
        return true;
      } else if (pID == 4) {
        setValues({
          ...values,
          ['silverGuardType']: getSilverGuardTypeList.data.listValues.filter((o) =>
            o.value.includes('SG')
          )[0].value,
        });
        return true;
      }
    }

    return false;
  }

  return (
    <div>
      <Snackbar
        open={fileFetchIsError}
        message={"Couldn't retrieve file"}
        status="error"
        duration={3000}
        onClose={() => setFileFetchIsError(false)}
      />
      {IsLoading() == true ? (
        <LoadingIndicator />
      ) : (
        <div>
          {/*getServiceFormTextQuery.data != null && getCheckoutSituationId.data != null && checkOutSituationFormsQuery.data != null &&*/}
          <div style={{ marginTop: '10px' }}>
            <div className="panel panel-default" style={{ minWidth: '350px' }}>
              <div className="panel-body" style={{ padding: '1em' }}>
                <div
                  className="btn-group-justified noPrint"
                  style={{ display: 'flex', justifyContent: 'center' }}
                >
                  {printAllFormsQuery.isFetching ? (
                    <LoadingIndicator style={{ margin: '0 1em' }} />
                  ) : (
                    <Button
                      size="small"
                      variant="contained"
                      id="btnPrintAllForms"
                      name="PrintAllForms"
                      className="btn btn-primary"
                      style={{ color: 'white', margin: '0 0.5em 0 0.5em' }}
                      onClick={() => {
                        if (showAdditionalInfo()) {
                          setOpenAdditionalInfoModal(true);
                        } else {
                          printAllFormsQuery.refetch();
                        }
                      }}
                    >
                      {'Print All Forms'}
                    </Button>
                  )}
                  {/*<Button
                    size="small"
                    variant="contained"
                    id="btnOrderForms"
                    name="OrderForms"
                    className="btn btn-primary"
                    style={{ color: 'white', margin: '0 0.5em 0 0.5em' }}
                    onClick={() => {
                      navigate(
                        `/${routePrefix}/AppPackage/OrderForm?id=${urlParams.get('id')}&productid=${urlParams.get('productid')}&bline=${urlParams.get('bline')}`
                      );
                    }}
                  >
                    Order Forms
                  </Button>*/}
                  {printCheckListQuery.isFetching ? (
                    <LoadingIndicator style={{ margin: '0 1em' }} />
                  ) : (
                    <Button
                      size="small"
                      variant="contained"
                      id="btnPrintChecklist"
                      name="PrintChecklist"
                      className="btn btn-primary"
                      style={{ color: 'white', margin: '0 0.5em 0 0.5em' }}
                      onClick={() => {
                        printCheckListQuery.refetch();
                      }}
                    >
                      {'Print Checklist'}
                    </Button>
                  )}
                </div>
              </div>
            </div>
          </div>
          {(productID === 7 || productID === 9) && (
            <Alert
              severity="warning"
              color="warning"
              style={{ backgroundColor: 'rgb(255, 244, 229)' }}
            >
              {eAppLiteWarning()}
            </Alert>
          )}
          <hr />
          <div className="panel panel-default">
            <div className="panel-body">
              {paramsForm != null && <HandleParamsForm />}

              <hr />
              <div style={{ padding: '1em' }}>
                {serviceForms != null &&
                  serviceForms.map((f, index) => (
                    <div key={'form_' + index}>
                      <label style={{ margin: '0.5em 0 0.5em 0' }} id={f.value}>
                        {f.text}
                      </label>
                    </div>
                  ))}
              </div>
            </div>
          </div>
          <div>
            {forms.length > 0 ? (
              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell align="left">Form</TableCell>
                      <TableCell align="left">Description</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {forms.map((row, index) => (
                      <TableRow key={row.id + '-' + index}>
                        {row.isApplication == true ? (
                          <TableCell component="th" scope="row" align="left">
                            <button
                              title="Generate and print this form"
                              style={{
                                backgroundColor: 'transparent',
                                border: 'none',
                                color: '#0366d6',
                                padding: '0',
                              }}
                              onClick={() => {
                                console.log("set form id: " + row.formId);
                                setSelectedFormID(row.formId);
                              }}
                            >
                              <DescriptionOutlinedIcon
                                fontSize="small"
                                style={{ verticalAlign: 'middle', marginRight: 4 }}
                              />
                              {row.formId}{' '}
                              {printFormQuery.isFetching && selectedFormID === row.formId ? (
                                <CircularProgress size={16} style={{ marginLeft: '.5rem' }} />
                              ) : (
                                ''
                              )}
                            </button>
                          </TableCell>
                        ) : (
                          <TableCell component="th" scope="row" align="left">
                            <a
                              role="button"
                              href="#"
                              title="Open PDF in a new tab"
                              onClick={(e) => {
                                e.preventDefault();
                                handleSecuredFile(row.formId);
                              }}
                              id={row.formId}
                              target="_blank"
                              rel="noreferrer"
                            >
                              <OpenInNewOutlinedIcon
                                fontSize="small"
                                style={{ verticalAlign: 'middle', marginRight: 4 }}
                              />
                              {row.formId}{' '}
                              {fileFetchingID === row.formId ? (
                                <CircularProgress size={16} style={{ marginLeft: '.5rem' }} />
                              ) : (
                                ''
                              )}
                            </a>
                          </TableCell>
                        )}
                        <TableCell component="th" scope="row" align="left">
                          {row.formDescription}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <TableContainer
                component={Paper}
                style={{ textAlign: 'center', fontSize: 'larger', padding: '2em' }}
              >
                No situation exists for the selected State and product. Please reach out to CASG
                management to discuss having this product approved in the selected State.
              </TableContainer>
            )}
          </div>

          {values != null &&
            getGenderList.data != null &&
            getYesNoList.data != null &&
            getStateList.data != null && (
              <Dialog
                open={openAdditionalInfoModal}
                onClose={(_e, reason) => {
                  if (reason !== 'backdropClick') setOpenAdditionalInfoModal(false);
                }}
                maxWidth="lg"
                fullWidth
              >
                <DialogTitle>Additional Form Information</DialogTitle>
                <DialogContent>
                  If you complete the additional information below, policy value fields of the state
                  disclosure form will be calculated and filled in.
                  <div style={{ padding: '1.25em 0 0 0' }}>
                    <div className="row" style={modalRow}>
                      <div className="col">Do you want to complete the state disclosure?</div>
                      <div className="col">
                        <Select
                          labelId={'state-disclosure' + 'demo-simple-select-label'}
                          id={'state-disclosure' + '-select'}
                          style={{ width: 'auto' }}
                          onChange={(e) => {
                            setStateDisclosure(e.target.value);
                          }}
                          value={stateDisclosure}
                        >
                          {getYesNoList.data?.filter(r => r.text === 'Yes' || r.text === 'No').map((p, index) => (
                            <MenuItem key={p.value + '-' + index} value={p.value}>
                              {p.text}
                            </MenuItem>
                          ))}
                        </Select>
                      </div>
                    </div>

                    <div className="row" style={modalRow}>
                      <div className="col">Client Name</div>
                      <div className="col">
                        <TextField
                          id={'standard-basic'}
                          onChange={(e) => {
                            handleDataChange('clientName', e.target.value);
                          }}
                          value={values.clientName}
                          error={errors.clientName}
                          helperText={errors.clientName}
                          style={{ width: '15em' }}
                        />
                      </div>
                    </div>
                    <div className="row" style={modalRow}>
                      <div className="col">Product Type</div>
                      <div className="col">
                        <Select
                          labelId={'plan type' + 'demo-simple-select-label'}
                          id={'plan type' + '-select'}
                          style={{ width: 'auto', maxWidth: '15em' }}
                          onChange={(e) => {
                            handleDataChange('silverGuardType', e.target.value);
                          }}
                          value={values.silverGuardType}
                          error={errors.silverGuardType}
                        >
                          {productID == 4 &&
                            getSilverGuardTypeList.data.listValues
                              .filter((o) => o.value.includes('SG'))
                              .map((p, index) => (
                                <MenuItem key={p.value + '-' + index} value={p.value}>
                                  {p.text}
                                </MenuItem>
                              ))}
                          {(productID == 15 || productID == 16) &&
                            getSilverGuardTypeList.data.listValues
                              .filter((o) => o.value.includes('OLA'))
                              .map((p, index) => (
                                <MenuItem key={p.value + '-' + index} value={p.value}>
                                  {p.text}
                                </MenuItem>
                              ))}
                        </Select>
                      </div>
                    </div>
                    <div className="row" style={modalRow}>
                      <div className="col">Age (50 - 80)</div>
                      <div className="col">
                        <TextField
                          InputLabelProps={{ shrink: true, min: 50, max: 80 }}
                          id={'standard-basic'}
                          onChange={(e) => {
                            handleDataChange('age', e.target.value);
                          }}
                          error={errors.age}
                          helperText={errors.age}
                          value={values.age}
                          type="number"
                          style={{ width: '15em' }}
                        />
                      </div>
                    </div>
                    <div className="row" style={modalRow}>
                      <div className="col">Sex</div>
                      <div className="col">
                        <Select
                          labelId={'sex' + 'demo-simple-select-label'}
                          id={'sex' + '-select'}
                          style={{ width: 'auto' }}
                          onChange={(e) => {
                            handleDataChange('sex', e.target.value);
                          }}
                          value={values.sex}
                          error={errors.sex}
                        >
                          {getGenderList.data.listValues.map((p, index) => (
                            <MenuItem key={p.value + '-' + index} value={p.value}>
                              {p.text}
                            </MenuItem>
                          ))}
                        </Select>
                      </div>
                    </div>
                    <div className="row" style={modalRow}>
                      <div className="col">ADB?</div>
                      <div className="col">
                        <FormControl>
                          <Select
                            labelId={'adb' + 'demo-simple-select-label'}
                            id={'adb' + '-select'}
                            style={{ width: 'auto' }}
                            onChange={(e) => {
                              handleDataChange('adb', e.target.value);
                            }}
                            value={values.adb}
                            error={errors.adb}
                          >
                            {getYesNoList.data?.filter(r => r.text === 'Yes' || r.text === 'No').map((p, index) => (
                              <MenuItem key={p.value + '-' + index} value={p.value}>
                                {p.text}
                              </MenuItem>
                            ))}
                          </Select>
                          <FormHelperText id="adb-helper-text" style={{ color: 'red' }}>
                            {errors.adb}
                          </FormHelperText>
                        </FormControl>
                      </div>
                    </div>
                    <div className="row" style={modalRow}>
                      <div className="col">Tobacco?</div>
                      <div className="col">
                        <Select
                          labelId={'tobacco' + 'demo-simple-select-label'}
                          id={'tobacco' + '-select'}
                          style={{ width: 'auto' }}
                          onChange={(e) => {
                            handleDataChange('tobacco', e.target.value);
                          }}
                          value={values.tobacco}
                        >
                          {getYesNoList.data?.filter(r => r.text === 'Yes' || r.text === 'No').map((p, index) => (
                            <MenuItem key={p.value + '-' + index} value={p.value}>
                              {p.text}
                            </MenuItem>
                          ))}
                        </Select>
                      </div>
                    </div>
                    <div className="row" style={modalRow}>
                      <div className="col">Amount Ins</div>
                      <div className="col">
                        <TextField
                          InputLabelProps={{ shrink: true, min: 50, max: 80 }}
                          id={'standard-basic'}
                          onChange={(e) => {
                            handleDataChange('amountIns', e.target.value);
                          }}
                          error={errors.amountIns}
                          helperText={errors.amountIns}
                          defaultValue={0}
                          value={
                            values.amountIns === null ||
                            values.amountIns === undefined ||
                            Number.isNaN(values.amountIns)
                              ? 0
                              : values.amountIns
                          }
                          type="number"
                          style={{ width: '15em' }}
                        />
                      </div>
                    </div>
                    <div className="row" style={modalRow}>
                      <div className="col">Agent Name</div>
                      <div className="col">
                        <TextField
                          InputLabelProps={{ shrink: true, min: 50, max: 80 }}
                          id={'standard-basic'}
                          onChange={(e) => {
                            handleDataChange('agentName', e.target.value);
                          }}
                          error={errors.agentName}
                          helperText={errors.agentName}
                          value={values.agentName}
                          style={{ width: '15em' }}
                        />
                      </div>
                    </div>
                    <div className="row" style={modalRow}>
                      <div className="col">Agency</div>
                      <div className="col">
                        <TextField
                          InputLabelProps={{ shrink: true, min: 50, max: 80 }}
                          id={'standard-basic'}
                          onChange={(e) => {
                            handleDataChange('agency', e.target.value);
                          }}
                          error={errors.agency}
                          helperText={errors.agency}
                          value={values.agency}
                          style={{ width: '15em' }}
                        />
                      </div>
                    </div>
                    <div className="row" style={modalRow}>
                      <div className="col">Agency Address</div>
                      <div className="col">
                        <TextField
                          InputLabelProps={{ shrink: true, min: 50, max: 80 }}
                          id={'standard-basic'}
                          onChange={(e) => {
                            handleDataChange('address', e.target.value);
                          }}
                          error={errors.address}
                          helperText={errors.address}
                          value={values.address}
                          style={{ width: '15em' }}
                        />
                      </div>
                    </div>
                    <div className="row" style={modalRow}>
                      <div className="col">City</div>
                      <div className="col">
                        <TextField
                          InputLabelProps={{ shrink: true, min: 50, max: 80 }}
                          id={'standard-basic'}
                          onChange={(e) => {
                            handleDataChange('city', e.target.value);
                          }}
                          error={errors.city}
                          helperText={errors.city}
                          value={values.city}
                          style={{ width: '15em' }}
                        />
                      </div>
                    </div>
                    <div className="row" style={modalRow}>
                      <div className="col">State</div>
                      <div className="col">
                        <FormControl>
                          <Select
                            labelId={'state' + 'demo-simple-select-label'}
                            id={'state' + '-select'}
                            style={{ width: 'auto' }}
                            onChange={(e) => {
                              let result = getStateList.data.find(
                                (s) => s.code === e.target.value
                              );
                              setValues({
                                ...values,
                                ['state']: result.code,
                                ['stateID']: result.id,
                              });
                            }}
                            value={values.state}
                            error={errors.state}
                          >
                            {getStateList.data.map((p, index) => (
                              <MenuItem key={p.code + '-' + index} value={p.code}>
                                {p.text}
                              </MenuItem>
                            ))}
                          </Select>
                          <FormHelperText id="state-helper-text" style={{ color: 'red' }}>
                            {errors.state}
                          </FormHelperText>
                        </FormControl>
                      </div>
                    </div>
                    <div className="row" style={modalRow}>
                      <div className="col">Agency ZIP Code</div>
                      <div className="col">
                        <TextField
                          InputLabelProps={{ shrink: true, min: 50, max: 80 }}
                          id={'standard-basic'}
                          onChange={(e) => {
                            handleDataChange('zipCode', e.target.value);
                          }}
                          error={errors.zipCode}
                          helperText={errors.zipCode}
                          value={values.zipCode}
                          style={{ width: '15em' }}
                        />
                      </div>
                    </div>
                    <div className="row" style={modalRow}>
                      <div className="col">Agency Phone</div>
                      <div className="col">
                        <FormControl>
                          <MaskedInput
                            mask={[
                              '(',
                              /[1-9]/,
                              /\d/,
                              /\d/,
                              ')',
                              ' ',
                              /\d/,
                              /\d/,
                              /\d/,
                              '-',
                              /\d/,
                              /\d/,
                              /\d/,
                              /\d/,
                            ]}
                            className="form-control"
                            placeholder="(XXX) XXX-XXXX"
                            guide={true}
                            id="my-input-id-phone"
                            value={values.phone}
                            onChange={(e) => {
                              handleDataChange('phone', e.target.value);
                            }}
                            variant="outlined"
                            margin="dense"
                            style={{ width: '15em' }}
                            render={(ref, props) => (
                              <TextField inputRef={ref} {...props} variant="standard" />
                            )}
                          />
                          <FormHelperText id="phone-helper-text" style={{ color: 'red' }}>
                            {errors.phone}
                          </FormHelperText>
                        </FormControl>
                      </div>
                    </div>
                  </div>
                </DialogContent>
                <DialogActions>
                  <div className="row" style={{ textAlign: 'center' }}>
                    <Button
                      style={{ color: 'white' }}
                      size="small"
                      variant="contained"
                      className="btn btn-danger"
                      id="btnClosePrintAllForms"
                      onClick={() => {
                        setOpenAdditionalInfoModal(false);
                      }}
                    >
                      Close
                    </Button>
                    <Button
                      style={{ color: 'white' }}
                      size="small"
                      variant="contained"
                      className="btn btn-primary"
                      id="btnPrintAllFormsAdditional"
                      onClick={() => {
                        Submit();
                      }}
                    >
                      Print All Forms
                    </Button>
                  </div>
                </DialogActions>
              </Dialog>
            )}
        </div>
      )}
    </div>
  );
}
